import BaseModule from './BaseModule'

class PositionModule extends BaseModule {
    constructor() {
            super()
        }
        // 获取职位列表数据
    getPositionList(params) {
            return this.get(`/api/position` + params)
        }

        //获取职位tag
    getPositionTag() {
        return this.get(`/api/position/types`)
    }
        // 职位名称搜索
    searchPositionName(params) {
            return this.get(`/api/position` + params)
        }
        // 获取公司列表数据
    getCompanyList(params) {
            return this.get(`/api/position/company` + params)
        }
        // 公司名称搜索
    searchCompanyName(params) {
            return this.get(`/api/position/company` + params)
        }
        // 创建公司
    createCompany(params) {
            return this.post(`/api/position/company`, params)
        }
        // 获取公司福利数据
    getCompanyWelfare() {
            return this.post(`/api/resource/treatment`)
        }
        // 获取编辑的公司信息
    getEditCompanyMsg(id) {
            return this.get(`/api/position/company/` + id)

        }
        // 提交编辑后的公司信息
    SendEditCompanyMsg(id, params) {
            return this.put(`/api/position/company/` + id, params)
        }
        // 添加职位
    addPositionMsg(params) {
            return this.post(`/api/position`, params)
        }
        // 编辑职位
    editPositionMsg(id, params) {
            return this.put(`/api/position/` + id, params)
        }
        // 获取职位详情
    getPositionDetails(params) {
            return this.get(`/api/position/` + params)
        }
        // 获取职位详情中评论数据
    getPositionComment(params) {
            return this.get(`/api/position/` + params)
        }
        // 获取投递人数列表页数据
    getDeliveryNumber(params) {
            return this.post(`/api/cv/deliver`, params, {
                headers: {
                    'X-HTTP-Method-Override': 'GET'
                }
            })
        }
        // 获取当前用户所属公司信息
    getUserCompanyMsg() {
        return this.get(`/api/personal/company`)
    }

     // 刷新职位信息
     refresh8List(id) {
        return this.put(`/api/position/${id}/refresh`)
    }
}

export default new PositionModule()


// WEBPACK FOOTER //
// ./src/api/PositionModule.js